import React, { useEffect, useState } from "react";

import { Image, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import APButton from "../components/APButton";
import { useVocabIntl } from "../hooks/useVocabTranslation";

function APCompleteDialog({ open, onNext }: { open: boolean; onNext: any }) {
  const [isOpen, setOpen] = useState(false);
  const { getFormattedString, APFormattedMessage } = useVocabIntl();

  useEffect(() => {
    setOpen(open);
  }, [open]);

  const onContinue = () => {
    onNext();
  };

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={() => setOpen(false)} closeOnEsc={false}>
      <ModalOverlay>
        <ModalContent>
          <ModalHeader bg={"lightBlue.500"}>
            <Text width={"100%"} textAlign="center" fontSize={"2xl"} fontWeight="bold">
              <APFormattedMessage id="completed-exercise-title" />
            </Text>
          </ModalHeader>

          <ModalBody padding={0} bg={"lightBlue.500"}>
            <Image height={"100%"} maxHeight={"176px"} minHeight={"4rem"} width={"auto"} alignSelf={"center"}
                   src={`${process.env.REACT_APP_BASE_URL}/complete.png`} />
          </ModalBody>

          <ModalFooter className="ap-dialog-footer" sx={{ justifyContent: "center" }}>
            <APButton variant={"solid"}
                      onClick={() => onContinue()}
                      aria-label={getFormattedString('aria-label-go-to-recap-button')}>
              <APFormattedMessage id="see-my-recap-button" />
            </APButton>
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}

export default APCompleteDialog;
